
$(document).ready(function() {
    $('.accordion-title').click(function(event) {
        event.preventDefault();  // Prevent the default action of the link

        // Find the currently active accordion and close it
        var currentlyActive = $('.herbs-accordion .accordion-title.active');
        if (currentlyActive.length && currentlyActive[0] !== this) {
            currentlyActive.closest('.herbs-accordion').find('.accordion-content').slideUp();
            currentlyActive.removeClass('active');
        }

        // Toggle the clicked accordion
        $(this).closest('.herbs-accordion').find('.accordion-content').slideToggle();
        $(this).toggleClass("active");
    });


  $('.moreless-button').click(function () {
    var podcastDetail = $(this).closest('.formulated-detail');
    var moreText = podcastDetail.find('.moretext');

    $('.formulated-detail').not(podcastDetail).find('.moretext').slideUp();
    $('.moreless-button').not(this).text("Read more");

    moreText.slideToggle();

    // Toggle the "Read more"/"Read less" text
    if ($(this).text() == "Read more") {
        $(this).text("Read less").addClass("active");
        
    } else {
        $(this).text("Read more").removeClass("active");
      
    }
});



  
});

$(document).ready(function () {
    $('.tapper-btn').click(function () {
        $(".flip-card").toggleClass("active");
    });

    $(window).scroll(function () {
        if ($(window).scrollTop() > 50) {
            $(".flip-card").removeClass("active");
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const radios = document.querySelectorAll('.card .swatch-col input[type="radio"]');
    const selectDropdown = document.querySelector('.product-converter__dropdown .select__select');

    // Function to activate the card when a radio option is changed
    radios.forEach(radio => {
        radio.addEventListener('change', function() {
            // Remove 'active' class from all cards
            document.querySelectorAll('.card').forEach(card => {
                card.classList.remove('active');
            });

            // Add 'active' class to the selected card
            if (this.checked) {
                const card = this.closest('.card');
                card.classList.add('active');

                // Synchronize dropdown with radio option
                selectDropdown.value = this.value;
            }
        });
    });

    // Function to activate the card when the dropdown option is changed
    if (selectDropdown) {
        selectDropdown.addEventListener('change', function() {
            const selectedOption = selectDropdown.value.trim();

            // Remove 'active' class from all cards
            document.querySelectorAll('.card').forEach(card => {
                card.classList.remove('active');
            });

            // Find the corresponding radio button and activate its card
            radios.forEach(radio => {
                if (radio.value === selectedOption) {
                    radio.checked = true;
                    const card = radio.closest('.card');
                    card.classList.add('active');
                }
            });
        });
    }

    // Initial check to set the active class based on pre-checked radio button
    radios.forEach(radio => {
        if (radio.checked) {
            const card = radio.closest('.card');
            card.classList.add('active');

            // Synchronize dropdown with pre-checked radio option
            selectDropdown.value = radio.value;
        }
    });
});





// document.addEventListener('DOMContentLoaded', function() {
//     // Select all radio inputs inside the cards
//     const radios = document.querySelectorAll('.card .swatch-col input[type="radio"]');

//     radios.forEach(radio => {
//         radio.addEventListener('change', function() {
//             // Remove the 'active' class from all cards
//             document.querySelectorAll('.card').forEach(card => {
//                 card.classList.remove('active');
//             });

//             // Find the closest card and add the 'active' class when the radio is checked
//             if (this.checked) {
//                 const card = this.closest('.card');
//                 card.classList.add('active');
//             }
//         });
//     });
// });

